import { gql } from '@apollo/client/core';

export const VP_ERROR_FIELDS = gql`
  fragment VPErrorFields on VpError {
    message
    path
  }
`;
